import { render } from "./PopoverMessages.vue?vue&type=template&id=a36805f2&scoped=true"
import script from "./PopoverMessages.vue?vue&type=script&lang=js"
export * from "./PopoverMessages.vue?vue&type=script&lang=js"

import "./PopoverMessages.vue?vue&type=style&index=0&id=a36805f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36805f2"]])

export default __exports__